module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter",
    attrs: {
      "id": "section_chapter--num_1--seq_4"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_105843-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675095_toc"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("CHAPTER ONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("‘THE TROUBLE with you, Angelo,’ said the Count severely, ‘is that you lack the "), _c('i', [_vm._v("dono di coraggio")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00002"
    }
  }, [_vm._v("‘That is perfectly true,’ said Angelo, ‘but am I to blame? Courage is a gift indeed, a great and splendid gift, and it is idle to pretend that any ordinary person can insist on receiving it; or go and buy it in the Black Market. We who have not been given the "), _c('i', [_vm._v("dono di coraggio")]), _vm._v(" suffer deeply, I assure you. We suffer so much, every day of our lives, that if there were any justice in the world we should receive sympathy, not reproof.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00003"
    }
  }, [_vm._v("With the back of his hand he rubbed a tear from his cheek, and turned away to look through the tall window at the splendid view of Rome on which it opened. In the westering sun the walls of the buildings were the colour of ripe peaches; the domes of several churches rose serenely, firmly round and steeply nippled like the unimpaired and several breasts of a Great Mother whose innumerable offspring, too weak to drain them, had even lacked sufficient appetite to use them much; while in half a dozen places, within easy reach of sight, Victory in a four-horsed chariot drove superbly through the golden air. Soft green foliage clothed the river-bank, and somewhere a military band was playing a gallant march. How beautiful was Rome, how beautiful all the land of Italy!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00004"
    }
  }, [_vm._v("Sitting behind his handsome large table – inlaid with intricately patterned brass about its flanks and furnished with a brass inkstand as big as a couple of flower-pots, with a statuette in bronze of the Wolf and the Twins, and a signed photograph of the Duce – seated in state though he was, the Count felt a softening of his heart, and his hands which had "), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("lain flat and severe upon the table half-rose, half-turned their palms, in a little gesture of understanding and sympathy; a gesture like the prelude to a softly acquiescent shrug. Angelo was a good-looking boy. True, he was very dirty, his ill-made uniform was sweat-stained and caked with dust, his left knee showed through a long rent in his breeches, his right boot was tied with string to keep a loose sole in position, and he stank a little; but his black hair curled and the bones of his face were as comely as if Donatello in his prime had carved them; he had eyes like his mother’s, and in his voice the echoes rose and fell of hers.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00005"
    }
  }, [_vm._v("With the fingers of his left hand the Count played a small tune upon the table and thought of Angelo’s mother when she was seventeen. His estate of Pontefiore, in the Tuscan hills between Siena and Florence, had always been renowned for the prettiness of its peasant-girls and the excellence of its wine, but in a year when the vintage was better than anyone could remember, and the girls – or so it had seemed to him, in the flush of his own youth – were more enticing than ever before, Angelo’s mother had stolen all the light of the sky and left in shadow every other prospect of pleasure. Her lips and her long fingers and the suppleness of her waist! The round of her hips and the white of her knees when she stooped with a lifting skirt over the washing-trough with the women and the other girls; and then, when she turned to speak to him, the darkness and the laughter in her eyes! And how short, how tragically brief, had been their time together.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00006"
    }
  }, [_vm._v("Desolation like a sudden storm enclosed him in its hail and darkness when he thought of those vanished years. He, like Angelo, was now in need of sympathy, and for a moment his impulse was to rise, embrace him, and let their tears flow in a common stream of sorrow.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("But as he moved, restless in his chair, his glance encountered the Duce’s portrait: the autograph, the massive jaw, and the unyielding mouth. Though the Duce had lately been dismissed from his high office, and his Grand Council dissolved, the Count still kept the portrait on his table, for ")]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("it was signed "), _c('i', [_vm._v("Your friend")]), _vm._v(" "), _c('i', [_vm._v("Mussolini")]), _vm._v(", and he prided himself on loyalty. How often had those piercing eyes inspired him! They inspired him still, and with an effort, with reluctance, he dismissed his tender thoughts. Stiffening his muscles and sitting bolt upright, he cast out sadness like a recognized traitor, and instead of tears forced into his eyes the atrabilious gleam of the eyes in the photograph. Not only was he Count of Pontefiore, Angelo’s patron and once the lover of his dead mother; he was also Commanding Officer of the 914th Regiment of Tuscan Infantry, the Sucklings of the Wolf. He was Angelo’s Colonel, and when he spoke it was in a colonel’s voice.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00008"
    }
  }, [_vm._v("‘You are a soldier and it is your duty to be courageous,’ he said loudly. ‘The illustrious regiment in which you have had the honour to serve, and I the honour to command, is even now fighting with the most glorious courage in Calabria. By this time, perhaps, your comrades have slaughtered the last of the English invaders or driven them into the sea. And you, you alone deserting and disgracing them, have run away! You have run all the way from Reggio to Rome!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00009"
    }
  }, [_vm._v("‘The last time I saw my comrades,’ said Angelo, ‘they were all running away. I looked over my shoulder once or twice, and they were running as hard as they could. But none of them was so swift and determined as I, and therefore I am the first to arrive. But if you will have a little patience, I am sure that you will presently see your whole regiment here.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00010"
    }
  }, [_vm._v("‘Silence!’ cried the Count. ‘No one in my presence shall ever deny, or even dispute, the indomitable valour of my gallant men!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00011"
    }
  }, [_vm._v("He struck with an ivory ruler the gleaming surface of the table, and then, frowning a little, leaned forward and asked, ‘Is it really as bad as that?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00012"
    }
  }, [_vm._v("‘Quite as bad,’ said Angelo. ‘It has taken us a long time to lose the war, but thank heaven we have lost it at last, and there is no use in denying it.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00013"
    }
  }, [_vm._v("‘It is treason to say that.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00014"
    }
  }, [_vm._v("‘It is common sense.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00015"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("‘You are still a soldier,’ said the Count, ‘and you have ")]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("no right to talk about common sense. You are subject to military law, and since by your own confession you are guilty of cowardice and desertion – well, my friend, you know the penalty for that?’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00016"
    }
  }, [_vm._v("‘Death,’ said Angelo in a gloomy voice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00017"
    }
  }, [_vm._v("‘If I do my duty, you will certainly be shot.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00018"
    }
  }, [_vm._v("‘The English have been trying to shoot me for the last three years. In Cyrenaica I had the greatest difficulty in avoiding their bombs and bullets and shells. I had to run hundreds of miles to escape being killed. And now, after three years of that sort of thing, I come to see you, my patron and Commanding Officer, and almost the first thing you say is that you too want to murder me. Is there no difference at all between friend and foe?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00019"
    }
  }, [_vm._v("‘There is a great deal of difference,’ said the Count, ‘but a soldier’s duty is the same wherever you go.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00020"
    }
  }, [_vm._v("‘It is, however, only a very good soldier who always does his duty.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00021"
    }
  }, [_vm._v("‘That is worth bearing in mind,’ said the Count thoughtfully. ‘I am not eager, you must realize, to have you shot, for it would create an awkward precedent if, as you say, my whole regiment is now on its way to Rome. And yet, if I were openly to condone your cowardice, and wholly ignore the fact of your desertion, I should bring myself down to your level. I should stand shoulder to shoulder with you in dishonour.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00022"
    }
  }, [_vm._v("‘It would be a new experience for you,’ said Angelo. ‘During three years of war you have never stood shoulder to shoulder with me or with any of your men.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00023"
    }
  }, [_vm._v("The Count replied a trifle haughtily: ‘It is perfectly true that while you served with the regiment in Africa, I commanded it from Rome. But it is quite absurd for you to refer to the fact in so unpleasant a tone of voice. For you cannot deny that I set you a splendid example, since I have never abandoned my post, nor ever, in three years of war, run a single yard. And who else in the regiment can make such a boast?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00024"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘I give you my word,’ said Angelo, ‘that I was speaking ")]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("with perfect respect. I made a short and simple statement of fact, and I can’t see why that should be regarded as unfriendly criticism.’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00025"
    }
  }, [_vm._v("‘You are old enough to realize,’ said the Count, ‘that a statement of fact is nearly always damaging to someone. And furthermore,’ he continued in an animated voice, ‘you should ask yourself what would have happened if, as you appear to think proper, I had indeed commanded you in the field. I myself can perceive three possibilities. I might have been killed; I might have been seriously wounded or taken prisoner, and in either case debarred from further service; or I might have been dismissed from the Army for incompetence. And a pretty pickle you would be in to-day, if any of those things had occurred! You wouldn’t be standing before an old friend who is devoted to your welfare, but confronting a total stranger who didn’t care what happened to you!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00026"
    }
  }, [_vm._v("‘I confess,’ said Angelo, ‘that I hadn’t thought of that. I am only a private, and common soldiers often fail to appreciate the plans and the methods of senior officers. Your very habit of thought, indeed, sometimes appears strange and foreign to us.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00027"
    }
  }, [_vm._v("‘Lack of understanding is the greatest evil in the world,’ said the Count. ‘My God! If understanding came to our minds as readily as condemnation to our lips, how happy we should be! – Or should we?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00028"
    }
  }, [_vm._v("While the Count was pondering this question Angelo discreetly turned his back, and tearing the wristband from a ragged sleeve of his shirt, blew his nose on it. The sweat was cold on his body, and he had begun to shiver. He was very tired.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00029"
    }
  }, [_vm._v("He had folded the damp wristband, and was putting it into his trouser-pocket, when the inner door of the room was thrown noisily open, and a fat white-faced captain with very short legs and a nearly bald head came clumsily in and stammered, ‘The radio! the radio! They are going to make a special announcement!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00030"
    }
  }, [_vm._v("‘Who is going to make an announcement?’ asked the Count. ‘The Duce?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00032"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘No, no! It is the Allies, it is the Americans, it is General Eisenhower himself who is going to speak!’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00033"
    }
  }, [_vm._v("‘Nonsense!’ said the Count.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00034"
    }
  }, [_vm._v("‘But I have just heard them saying it, and the voice had an American accent. Stand by, it said. Stand by for one minute and you will hear General Eisenhower make an important announcement.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00035"
    }
  }, [_vm._v("‘Who gave you permission to listen to foreign broadcasting?’ asked the Count. ‘It is a grave and serious offence, as you well know.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00036"
    }
  }, [_vm._v("The Captain wiped his forehead with a yellow silk handkerchief, and stammering again, muttered, ‘But if I had not been listening I could not have told you about General Eisenhower’s announcement.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00037"
    }
  }, [_vm._v("‘That is so,’ said the Count. ‘It is a tolerable excuse, and I must admit that to show a strict regard for every trifling piece of legislation would lead us, eventually, into the deplorable ways of our good friends the Germans; which God forbid. – I shall come and listen to your illegal instrument.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00038"
    }
  }, [_vm._v("He rose, and with dignity led the way into the inner room, an office with maps upon the wall, where two smart young subalterns stood expectantly before a small wireless set. It was emitting the angry sounds of a far-off electric storm, but these suddenly gave way to what might have been the voice of a man with a hurricane in his lungs and a throat like the dome of St Peter’s.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00039"
    }
  }, [_vm._v("One of the subalterns hurriedly made an adjustment, the voice was reduced to human volume, and its accent became recognizably American. The tone was flat, the voice was soberly inflected. A plain man was speaking plainly, but every word he uttered was momentous, every sentence affected millions of lives, and he spoke with authority. Here was one of the decisive utterances of history. They were listening, thought the Count with enthusiasm, not merely to an American general, but to Clio herself. – And then the voice grew smaller, it receded to an infinite distance, and the electric storm was heard again, angrier than before, and now, as it seemed, filling all space.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00041"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘However,’ said the Count, ‘we have had the gist of it. We have been offered peace on honourable terms, we have accepted the offer, and an armistice has been signed. The war is over!’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00042"
    }
  }, [_vm._v("Angelo threw himself on to his knees, and grasping the Count’s left hand, covered it with kisses. ‘Peace!’ he exclaimed. ‘Peace has been restored to us, and now you will not require to have me shot!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00043"
    }
  }, [_vm._v("‘No, of course not,’ said the Count. ‘Of course not!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00044"
    }
  }, [_vm._v("‘And I shall no longer be miserable because I have not the "), _c('i', [_vm._v("dono di corragio")]), _vm._v(". In time of peace one can live well enough without courage, like everybody else.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00045"
    }
  }, [_vm._v("‘It is the eighth of September in the year nineteen forty three,’ said the Count. ‘It is five-and-twenty minutes to seven. We must forever remember the hour and the day, for they are part of our history. At this moment we and all Italy are stepping, like joyous pilgrims, into a new and happier age!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00046"
    }
  }, [_vm._v("The fat Captain was again wiping his forehead with his yellow handkerchief. ‘Do you suppose, sir,’ he asked, ‘that we shall be compelled to resign our commissions?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00047"
    }
  }, [_vm._v("‘Immediately,’ said the Count. ‘Now that the war is over, what need have we of commissions?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00048"
    }
  }, [_vm._v("‘I need mine to keep a roof over my head,’ said the Captain.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00049"
    }
  }, [_vm._v("‘Farewell, my mistress,’ murmured one of the subalterns.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00050"
    }
  }, [_vm._v("‘"), _c('i', [_vm._v("Our")]), _vm._v(" mistress,’ corrected the other. ‘You see, sir,’ he explained, ‘on a subaltern’s pay it is impossible to maintain a mistress who is both agreeable to the senses and presentable to one’s friends; but by using every economy Luigi and I have, for some time past, been able to share such a one. Now, of course, we shall have to relinquish her, and because she has spoiled my taste for any coarser fare, I can see for myself no prospect but emotional famine.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00051"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘Come, come,’ said the Count, ‘you are unduly pessimistic. We shall all have to make certain minor adjustments to accommodate ourselves to new conditions, and some of us, during the brief period of transition, may even suffer ")]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("small inconveniences. But we must not fret about them, we must ignore them, because at last, after three long years of fighting, we have won that for which we have always striven: Peace! Whatever trials you may have to endure, gentlemen, never forget that on the eighth of September, at five-and-twenty minutes to seven, you entered, after an eternity of suffering, the promised haven of peace.’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00052"
    }
  }, [_vm._v("At that moment the windows rattled in their frames, and the fat Captain said, ‘A thunderstorm is a bad augury for peace.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00053"
    }
  }, [_vm._v("‘It is not thunder,’ said Angelo in a trembling voice. ‘It is gunfire.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00054"
    }
  }, [_vm._v("‘Guns!’ exclaimed the Count. ‘Whose guns, and why should they be firing?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00055"
    }
  }, [_vm._v("‘They may be firing a "), _c('i', [_vm._v("feu de joie")]), _vm._v(",’ said the younger subaltern with a cynical smile.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00056"
    }
  }, [_vm._v("‘That is undoubtedly the explanation,’ said the Count. ‘They are shouting their welcome to peace!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00057"
    }
  }, [_vm._v("‘Perhaps they are firing against the English,’ said Angelo.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00058"
    }
  }, [_vm._v("‘Impossible,’ declared the Count. ‘The English are hundreds of miles away.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00059"
    }
  }, [_vm._v("‘They were coming very fast when I last saw them.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00060"
    }
  }, [_vm._v("‘But it’s unthinkable! And even if they have achieved the impossible, and arrived at the gates of Rome, why should they continue to fight against us when Clio herself, borrowing the lips of General Eisenhower, has declared an armistice?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00061"
    }
  }, [_vm._v("‘They may not have heard about it,’ said Angelo. ‘The English are frequently unaware of what goes on in Europe.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00062"
    }
  }, [_vm._v("‘Then we shall go and inform them,’ declared the Count. ‘You and I, my dear Angelo, shall be the first to give them the good news that henceforth we and they must live together in perfect amity and mutual assistance. Come, Angelo, let us waste no time.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00063"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("The windows rattled more violently as the gunfire grew louder, and Angelo tried to evade his errand with one excuse after another. But the Count would listen to none of them, and presently they were driving out of Rome towards the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("aerodrome that lies along the Appian Way. For that was the direction from which the firing came.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00064"
    }
  }, [_vm._v("The evening was now darkening, and against the first veils of twilight the flashing of the guns was faintly hued with orange. Every shell that was fired made Angelo wince as though he were equipped, like the field-pieces, with a recoil-mechanism; but the Count was deeply interested in what he saw.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00065"
    }
  }, [_vm._v("‘Why, bless my soul,’ he declared, ‘they are Germans. It’s a German battery! The poor Tedeschi, they have not heard the news. No one ever tells them anything!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00066"
    }
  }, [_vm._v("Briskly leaving his motor-car he approached the German officer in command, saluted him smilingly, clapped him on the shoulder with his other hand, and with a great deal of geniality started to explain that an armistice had been signed, and the war was over.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00067"
    }
  }, [_vm._v("The German, already in a vile temper, listened for five seconds only, and then interrupted to abuse the Count in a loud voice and with vulgar detail.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00068"
    }
  }, [_vm._v("‘So you also are a traitor!’ he shouted. ‘You too are a rebel, are you, like the mutinous swine over there whom we are now liquidating?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00069"
    }
  }, [_vm._v("‘Mutinous? Surely the English have not mutinied?’ asked the Count.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00070"
    }
  }, [_vm._v("‘Not the English, you blockhead, but those garlic-eating Judases, your fellow-countrymen!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00071"
    }
  }, [_vm._v("‘It is impossible!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00072"
    }
  }, [_vm._v("‘They told us the war was over – and this is our answer.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00073"
    }
  }, [_vm._v("‘You cannot be serious. You are not firing against Italian soldiers?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00074"
    }
  }, [_vm._v("‘They may have been soldiers once,’ said the German. ‘Most of them are corpses now.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00075"
    }
  }, [_vm._v("‘But we are your allies,’ exclaimed the Count. ‘You cannot fire against us! Good heavens, even a German should realize that this is no way to behave.’ And turning toward the nearest gun-crew he shouted, ‘Cease fire immediately!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00076"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("The German officer at once drew his revolver, and pressing the muzzle against the Count’s stomach, declared in ")]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("a voice so hoarse that it drew a little blood – which he swallowed noisily – ‘You are under arrest. Move one inch or utter a single word, and I shall kill you!’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00077"
    }
  }, [_vm._v("The Count was hard put to it to comply, for there were twenty things he wanted to say, but fortunately, before the strain became intolerable, there was a compelling sound in the air, a sibilance that swiftly grew louder and came nearer, and with a common impulse he and the German threw themselves flat on the ground.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00078"
    }
  }, [_vm._v("Within half a minute the Count had recovered consciousness, and sitting up he perceived that the shell, which seemingly had landed within a yard of the nearby gun, had instantly killed all its crew, while the German officer had been mortally wounded by a heavy splinter. Towed by their tractors, the remaining guns of the battery were moving to a new position.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00079"
    }
  }, [_vm._v("Though beyond human aid the German officer was still conscious, and the Count was able to deliver, without interruption, a brief lecture on the evils of intolerance.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00080"
    }
  }, [_vm._v("‘You Tedeschi,’ he concluded, ‘have persistently underrated us, and made light of our military qualities. The excellence of our artillery, for example, is quite generally admitted by impartial observers, and our gunners have frequently used it to great advantage. But have you ever praised them? Never! It may be, of course, that until now you have never seen for yourself what they can do –’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00081"
    }
  }, [_vm._v("A barely human sound came from the German’s lips, and his booted heels twitched on the ground. The Count, after stooping to examine him, shrugged his shoulders and murmured, ‘They will never learn.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00082"
    }
  }, [_vm._v("He returned to his car and was about to drive away when, from somewhere on the ground, a voice in agitation cried, ‘A moment, please! Wait a moment, do!’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00083"
    }
  }, [_vm._v("‘My dear Angelo,’ said the Count, ‘I had quite forgotten you. Where have you been? Underneath the car?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00084"
    }
  }, [_vm._v("‘Of course I have,’ said Angelo. ‘It was the obvious place to choose.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105843-00085"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘And while you were lying there, safe and snug, I came ")]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("near to losing my life,’ said the Count. ‘Several Germans, less fortunate than I, were killed outright.’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105843-00086"
    }
  }, [_vm._v("‘By the English?’ asked Angelo.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00087"
    }
  }, [_vm._v("‘No, no!’ cried the Count. ‘Really, my dear boy, your appreciation of the situation is woefully at fault. They are Italian gunners, our own splendid soldiers, who are now engaged in battle with the Germans. Look there! Oh, bravo, bravo! They have found the range again. I have always maintained that our artillery is first-class – and who will deny that now?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00088"
    }
  }, [_vm._v("‘Do you mean to tell me,’ asked Angelo, ‘that now, when we have stopped fighting against our enemies, we must go to war against our allies?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00089"
    }
  }, [_vm._v("‘Surely there is some better way of expressing the situation,’ said the Count, and driving slowly while he considered the problem, turned the car towards Rome. Behind them the night was loud and the sky lurid with gunfire. ‘From what we have just seen,’ he continued, ‘we may reasonably infer that the Germans are no longer, in fact, or strictly speaking, our allies; and if that is indeed the case, we must, before we can discuss the situation clearly, find some new and more accurate title for them.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00090"
    }
  }, [_vm._v("‘They will become our gaolers,’ said Angelo bitterly. ‘If they have turned against us they will hold the mountains to the north like a great door between us and the rest of the world, and all Italy will become a prison. We shall be the starving convicts and they will be the gaolers with whips in their hands.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00091"
    }
  }, [_vm._v("‘But you must remember,’ said the Count, ‘that now we have powerful friends who will come to rescue us. The English and the Americans will not allow the Germans to illtreat us. The English are already in Calabria, and we expect the Americans to land somewhere near Salerno either to-morrow or the day after. – That is in confidence, of course. – We may indeed be in the toils of Germany at this moment, but soon, very soon, the Americans and the English will come and liberate us. "), _c('i', [_vm._v("Pazienza!")]), _vm._v(" It will not be long.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_105843-00092"
    }
  }, [_vm._v("‘"), _c('i', [_vm._v("Speriamo")]), _vm._v(",’ said Angelo.")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7bbaf70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675095_chapter_01.vue
// module id = 69
// module chunks = 0